<template>
  <div class="wrapper">
    <header>
      <h1 :style="counterStyle">
        <span v-if="prefix != ''">{{ prefix }}</span
        >{{ counter }}<span v-if="suffix != ''">{{ suffix }}</span>
      </h1>
    </header>
    <div class="buttons">
      <button
        :class="[isStart ? 'active' : '']"
        @click="start"
        :disabled="isStart || isResume"
      >
        Start
      </button>
      <button
        :class="[isStop ? 'active' : '']"
        @click="stop"
        :disabled="isStop"
      >
        Stop
      </button>
      <button
        :class="[isResume ? 'active' : '']"
        @click="resume"
        :disabled="isResume || counter == endPoint"
      >
        Resume
      </button>
      <button @click="reset">Reset</button>
    </div>
    <div class="inputs">
      <input type="number" v-model="endPoint" placeholder="End Point" />
      <input type="number" v-model="duration" placeholder="Duration" />
      <input type="text" v-model="prefix" placeholder="Prefix" />
      <input type="text" v-model="suffix" placeholder="Suffix" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Counter",
  data() {
    return {
      counter: 0,
      isStop: false,
      isStart: false,
      isResume: false,
      duration: 10,
      endPoint: 5000,
      timer: "",
      prefix: "",
      suffix: "",
    };
  },
  computed: {
    counterStyle() {
      let style = "";
      if (this.counter <= 500) return;
      switch (this.counter) {
        case this.counter >= 501 && this.counter <= 800 ? this.counter : -1:
          style = { color: "brown" };
          break;
        case this.counter >= 801 && this.counter <= 1100 ? this.counter : -1:
          style = { color: "orange" };
          break;
        case this.counter >= 1101 && this.counter <= 1400 ? this.counter : -1:
          style = { color: "crimson" };
          break;
        default:
          style = { color: "navy" };
          break;
      }
      return style;
    },
  },
  methods: {
    time() {
      this.timer = setInterval(() => {
        this.counter++;
        if (this.counter == this.endPoint) this.stop();
      }, this.duration);
    },
    start() {
      this.isStart = !this.isStart;
      if (this.counter != 0 && this.isStop && !this.isResume) {
        this.counter = 0;
        this.time();
      } else this.time();
      this.isStop = false;
    },
    stop() {
      if (this.counter == 0) return;
      this.isStop = !this.isStop;
      this.isStart = false;
      this.isResume = false;
      if (this.isStop) clearInterval(this.timer);
      else this.start();
    },
    reset() {
      clearInterval(this.timer);
      this.counter = 0;
      this.isStop = false;
      this.isStart = false;
      this.isResume = false;
      this.prefix = "";
      this.suffix = "";
    },
    resume() {
      if (!this.isStop) return;
      this.isResume = true;
      this.isStart = true;
      this.start();
    },
  },
};
</script>

<style scoped>
header {
  display: flex;
  justify-content: center;
}
header h1 {
  width: 300px;
  text-align: center;
  margin: 40px 20px;
  font-size: 70px;
  word-wrap: break-word;
}
header span {
  color: black;
}
.buttons {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
button {
  border: none;
  outline: none;
  padding: 6px 12px;
  font-size: 20px;
  border-radius: 6px;
  cursor: pointer;
  background: #242493;
  color: #fff;
}
.active {
  background: rgb(168, 4, 4);
}
.buttons button:not(:first-child) {
  margin-left: 20px;
}

.inputs input:not(:first-child) {
  margin-left: 20px;
}
input {
  width: 110px;
  padding: 6px 8px;
  border: none;
  outline: none;
  border-radius: 4px;
  border: 1px solid #242493;
}

@media (max-width: 576px) {
  .buttons button:not(:first-child) {
    margin-left: 10px;
  }
  .inputs {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .inputs input {
    margin: 0 20px 10px 30px !important;
  }
}
</style>
